import Icon from '../../components/Icon.vue'

Icon.register({"brands/centercode":{"width":512,"height":512,"paths":[{"d":"M329.2 268.6C325.4 303.8 293.8 329.2 258.6 325.4 223.4 321.6 198 290 201.8 254.8 205.6 219.6 237.2 194.2 272.4 198 307.5 201.8 333 233.4 329.2 268.6zM243.4 503.7C96.7 496-8.2 365.5 10.1 224.3 21.3 137.7 75.9 67.4 149.2 32.3 310.2-44.8 498.9 69.7 503.9 248.9 508 395.9 385.5 511.1 243.4 503.7zM423.3 323.7C451.2 205.7 262.8 117.8 186.1 89.5 128.6 145.8 117 278.1 152.3 433.9 221.1 449.7 321.4 407.5 423.3 323.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/centercode.js
// module id = TF8t
// module chunks = 0